import React, { useEffect, useState } from 'react';
import { Link, useParams, useNavigate } from 'react-router-dom';
import { useLang } from '../i18n/translations';
import api from '../lib/api';
import { Button } from '../components/ui/button';
import { Clock, ChevronRight, ChevronLeft, User } from 'lucide-react';

const fmtDate = (d) => { const [y, m, day] = d.split('-'); return `${day}.${m}.${y}.`; };

export function ObavijestDetail() {
  const { id } = useParams();
  const { t } = useLang();
  const [notice, setNotice] = useState(null);

  useEffect(() => {
    api.get(`/notices/${id}`)
      .then((res) => setNotice(res.data))
      .catch(() => setNotice(null));
    window.scrollTo(0, 0);
  }, [id]);

  if (!notice) {
    return (
      <div className="max-w-4xl mx-auto px-4 py-24 text-center text-slate-500">
        Obavijest nije pronađena. <Link to="/obavijesti" className="text-[#001752] font-semibold underline">Nazad</Link>
      </div>
    );
  }

  return (
    <div className="bg-[#f8f9fd] min-h-screen py-10">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <Link to="/obavijesti" className="inline-flex items-center gap-1 text-sm text-slate-500 hover:text-[#001752] transition-colors duration-200 mb-6" data-testid="back-to-notices">
          <ChevronLeft className="h-4 w-4" /> {t('notices')}
        </Link>
        <div className="bg-white rounded-xl border border-slate-100 overflow-hidden">
          <div className="notice-banner notice-banner-lg"><span>OBAVIJEST</span></div>
          <div className="p-8">
            <h1 className="text-2xl lg:text-3xl font-bold text-[#0b1a3d] leading-snug mb-4" data-testid="notice-detail-title">{notice.title}</h1>
            <div className="flex flex-wrap items-center gap-4 text-sm text-slate-500 pb-6 border-b border-slate-100 mb-6">
              <span className="flex items-center gap-1.5"><Clock className="h-4 w-4" /> {t('published')}: {fmtDate(notice.date)}</span>
              <span className="flex items-center gap-1.5"><User className="h-4 w-4" /> {notice.author}</span>
            </div>
            <div className="text-slate-600 leading-relaxed whitespace-pre-line" data-testid="notice-detail-content">{notice.content}</div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default function Obavijesti() {
  const { t } = useLang();
  const navigate = useNavigate();
  const [notices, setNotices] = useState([]);

  useEffect(() => {
    api.get('/notices')
      .then((res) => setNotices(res.data))
      .catch((err) => console.error('Greška pri učitavanju:', err));
  }, []);

  return (
    <div className="bg-[#f8f9fd] min-h-screen">
      <div className="bg-white border-b border-slate-100">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
          <h1 className="text-4xl font-bold text-[#0b1a3d] mb-2" data-testid="obavijesti-title">{t('notices')}</h1>
          <p className="text-slate-500">Sve obavijesti Ministarstva privrede, Turističke zajednice i općina/gradova SBK/KSB.</p>
        </div>
      </div>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-10">
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {notices.map((n) => (
            <div key={n.id} className="bg-white rounded-xl border border-slate-100 overflow-hidden hover:shadow-xl hover:shadow-slate-200/70 transition-shadow duration-300 flex flex-col" data-testid={`notice-item-${n.id}`}>
              <div className="notice-banner"><span>OBAVIJEST</span></div>
              <div className="p-5 flex flex-col flex-1">
                <h3 className="font-bold text-[#0b1a3d] uppercase text-sm leading-snug mb-3">{n.title}</h3>
                <p className="text-sm text-slate-500 line-clamp-3 flex-1">{n.excerpt}</p>
                <div className="flex items-center justify-between mt-5 pt-4 border-t border-slate-50">
                  <span className="flex items-center gap-1.5 text-xs font-semibold text-slate-600">
                    <Clock className="h-3.5 w-3.5" /> {fmtDate(n.date)}
                  </span>
                  <Button size="sm" variant="outline" onClick={() => navigate(`/obavijesti/${n.id}`)} data-testid={`notice-read-${n.id}`}
                    className="border-slate-200 text-[#001752] hover:bg-[#001752] hover:text-white rounded-md text-xs transition-colors duration-200">
                    {t('readMore')} <ChevronRight className="h-3.5 w-3.5 ml-1" />
                  </Button>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
